import React from 'react';
import { useParams } from 'react-router-dom';
import FirstSectionPricing from './FirstSectionPricing';
import SecondPricingSection from './SecondPricingSection';

function PricingPage() {
    const { id } = useParams(); // Capture the 'id' from URL params
    const selectedPlanId = id ? parseInt(id) : null; // Parse 'id' and convert to number, or null if no id is provided

    return (
        <div>
            <FirstSectionPricing />
            <SecondPricingSection selectedPlanId={selectedPlanId} /> {/* Pass selectedPlanId */}
        </div>
    );
}

export default PricingPage;
